/** Shared admin nav order: daily (primary) vs occasional (more). */

export type AdminNavGroup = 'primary' | 'more';

export type AdminNavItem = {
  href: string;
  label: string;
  module: string;
  group: AdminNavGroup;
};

export const ADMIN_NAV_ITEMS: AdminNavItem[] = [
  { href: '/admin', label: 'Overview', module: 'dashboard', group: 'primary' },
  { href: '/admin/students', label: 'Students', module: 'students', group: 'primary' },
  { href: '/admin/blogs', label: 'Blogs', module: 'blogs', group: 'primary' },
  { href: '/admin/events', label: 'Events', module: 'events', group: 'primary' },
  { href: '/admin/bookings', label: 'Bookings', module: 'internships', group: 'primary' },
  { href: '/admin/consultations', label: 'Consultations', module: 'consultations', group: 'primary' },
  { href: '/admin/clinics', label: 'Clinics', module: 'clinics', group: 'more' },
  { href: '/admin/doctors', label: 'Doctors', module: 'doctors', group: 'more' },
  { href: '/admin/plans', label: 'Plans', module: 'subscriptions', group: 'more' },
  { href: '/admin/payments', label: 'Payments', module: 'payments', group: 'more' },
  { href: '/admin/withdrawals', label: 'Withdrawals', module: 'withdrawals', group: 'more' },
  { href: '/admin/referrals', label: 'Referrals', module: 'referrals', group: 'more' },
  { href: '/admin/promo-codes', label: 'Promo Codes', module: 'promo_codes', group: 'more' },
  { href: '/admin/settings', label: 'Settings', module: 'settings', group: 'more' },
  { href: '/admin/permissions', label: 'Permissions', module: 'permissions', group: 'more' },
];

export function isAdminMorePath(pathname: string): boolean {
  return ADMIN_NAV_ITEMS.some(
    (item) =>
      item.group === 'more' &&
      (pathname === item.href || pathname.startsWith(`${item.href}/`)),
  );
}
